import { render, staticRenderFns } from "./subindex.vue?vue&type=template&id=5e900580&"
import script from "./subindex.vue?vue&type=script&lang=js&"
export * from "./subindex.vue?vue&type=script&lang=js&"
import style0 from "./subindex.vue?vue&type=style&index=0&%40scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.7@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports